<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end mt-2">
    <img *ngIf="environment.partnerIdBSI == partnerId" src="assets/Logo-eSPAJK-syariah.png" width="250" height="auto">
    <img *ngIf="environment.partnerIdBSI !== partnerId" src="assets/Logo-eSPAJK.jpg" width="250" height="auto">
  </div>
  <div class="riplay-title">
    <h2 class="text-center mt-5 color-blue"><b>ELLISE Sales Dashboard</b></h2>
  </div>
  <div class="container mt-5 pt-4 form-header bg-white">
  </div>
</div>
<div class="container form-container pb-2">
  <div class="bg-white form-content pb-3 align-content-center mb-4">
    <p (click)="back()" class="px-2 cursor-pointer text-primary"><i class="bi bi-arrow-left"></i> Kembali</p>
    <div class="px-3">
      <h6 class="text-primary" *ngIf="environment.partnerIdBSI == partnerId">Calon Pihak Yang Diasuransikan</h6>
      <h6 class="text-primary" *ngIf="environment.partnerIdBSI !== partnerId">Data Tertanggung</h6>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Nama Calon Pihak Yang Diasuransikan</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Nama Lengkap</div>
        <div class="col text-end">{{summary.fullName}}</div>
      </div>
      <div class="row fs-14">
        <div class="col">Tanggal Lahir</div>
        <div class="col text-end">{{summary.dob | date:"dd-M-Y"}}</div>
      </div>
      <div class="row fs-14">
        <div class="col">Jenis Kelamin</div>
        <div class="col text-end">
          <span *ngIf="'F' === summary.gender">Wanita</span>
          <span *ngIf="'M' === summary.gender">Pria</span>
        </div>
      </div>
      <div class="row fs-14">
        <div class="col">Umur</div>
        <div class="col text-end">{{summary.entryAge}} Tahun</div>
      </div>
      <div class="row fs-14">
        <div class="col">Masa Asuransi</div>
        <div class="col text-end">{{summary.tenure}} Bulan</div>
      </div>
      <div class="row fs-14">
        <div class="col">No Aplikasi</div>
        <div class="col text-end">{{summary.applicationNo}}</div>
      </div>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Tanggal Mulai Asuransi</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Tanggal Akad Kredit</div>
        <div class="col text-end">{{summary.effectiveDate | date:"dd-M-Y"}}</div>
      </div>
      <div class="row fs-14" *ngIf="environment.partnerIdBSI == partnerId">
        <div class="col">Tanggal Akhir Asuransi</div>
        <div class="col text-end">{{summary.maturityDate | date:"dd-M-Y"}}</div>
      </div>
      <div class="row fs-14 mb-3">
        <div class="col">Kantor Cabang</div>
        <div class="col text-end">{{summary.branchDescription}}</div>
      </div>
      <h6 class="text-primary">Rincian Tagihan</h6>
      <div class="row fs-14">
        <div class="col">Nama Produk</div>
        <div class="col text-end">{{summary.loanTypeDesc}}</div>
      </div>
      <div class="row fs-14">
        <div class="col">Jenis Produk</div>
        <div class="col text-end" *ngIf="environment.partnerIdBSI == partnerId">Asuransi Jiwa Pembiayaan Kumpulan</div>
        <div class="col text-end" *ngIf="environment.partnerIdBSI !== partnerId">Asuransi Jiwa Kredit Kumpulan</div>
      </div>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Total Pembiayaan</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Uang Pertanggungan</div>
        <div class="col text-end">{{summary.totalSumAssured | currency: 'IDR' : 'symbol' : '4.0-0'}}</div>
      </div>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Kontribusi Dasar</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Premi Standar</div>
        <div class="col text-end">{{summary.standardPremi | currency: 'IDR' : 'symbol' : '4.0-0'}}</div>
      </div>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Kontribusi Tambahan</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Ekstra Premi</div>
        <div class="col text-end">{{summary.extraPremi | currency: 'IDR' : 'symbol' : '4.0-0'}}</div>
      </div>
      <div class="row fs-14">
        <div class="col" *ngIf="environment.partnerIdBSI == partnerId">Total Kontribusi</div>
        <div class="col" *ngIf="environment.partnerIdBSI !== partnerId">Total Premi</div>
        <div class="col text-end">{{summary.totalPremium | currency: 'IDR' : 'symbol' : '4.0-0'}}
        </div>
      </div>
      <div *ngIf="environment.partnerIdBSI == partnerId" class="row fs-14">
        <div class="col">Total Kontribusi/Total Pembiayaan</div>
        <div class="col text-end">{{ratio + 0.0001 | number : '1.4'}} %
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedItem.status == 'APPROVED'">
    <button class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadAcceptanceLetter()">
      <span *ngIf="!isLoading[0]"><i class="bi bi-arrow-down fw-bold"></i> Unduh Surat Akseptasi (CN)</span>
      <div *ngIf="isLoading[0]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button *ngIf="environment.partnerIdBSI == partnerId" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadBill()">
      <span *ngIf="!isLoading[1]"><i class="bi bi-arrow-down fw-bold"></i> Unduh Surat Tagihan</span>
      <div *ngIf="isLoading[1]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadRiplay()">
      <span *ngIf="!isLoading[2]"><i class="bi bi-arrow-down fw-bold"></i> Unduh RIPLAY Personal</span>
      <div *ngIf="isLoading[2]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadSPAJK()">
      <span><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJPK Syariah</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>

    <button *ngIf="!isLoading[3] && nasabah.nasabahNewCovering.partnerId == environment.partnerIdBTPN" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadSPAJKRiplay()">
      <span><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJK Dan RIPLAY</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <div *ngIf="!isLoading[3] && nasabah.nasabahNewCovering.partnerId == environment.partnerIdBTPN" >
      <button class="btn button-primary w-100 mb-2" type="button" (click)="changeBranchOffice()" [disabled]="isEligibleEndorseBranch">
        <span>Ubah Kantor Cabang</span>
        <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </button>
      <p *ngIf="isEligibleEndorseBranch" class="description-input text-center">Maaf perubahan Kantor Cabang Proses Kredit sudah tidak bisa dilakukan, silahkan melakukan pengajuan ulang.</p>

      <button class="btn button-primary w-100 mb-2" type="button" (click)="changeEffectiveDate()" [disabled]="isEligibleEndorseEffDate">
        <span>Ubah Tanggal Akad Kredit</span>
        <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </button>
      <p *ngIf="isEligibleEndorseEffDate" class="description-input text-center">Maaf perubahan Tanggal Akad Kredit sudah tidak bisa dilakukan, silahkan melakukan pengajuan ulang.</p>
    </div>

    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" class="btn btn-continue w-100 mb-2" type="button" (click)="editNameAppNo()" [disabled]="isEligibleEndorseNameAppNo">
      <span> Ajukan Perbaikan Nama Lengkap dan/atau No Aplikasi</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <p *ngIf="isEligibleEndorseNameAppNo" class="description-input text-center">Maaf Perbaikan Nama Lengkap dan/atau No Aplikasi tidak bisa dilakukan, silahkan melakukan pengajuan ulang.</p>
  </div>

  <div *ngIf="selectedItem.status == 'REJECTED'">
    <button class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadRejectionLetter()">
      <span *ngIf="!isLoading[0]"><i class="bi bi-arrow-down fw-bold"></i> Unduh Surat Penolakan</span>
      <div *ngIf="isLoading[0]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button class="btn button-outline-primary w-50 mb-2" type="button" (click)="downloadRiplay()">
      <span *ngIf="!isLoading[2]"><i class="bi bi-arrow-down fw-bold"></i> Unduh RIPLAY Personal</span>
      <div *ngIf="isLoading[2]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button class="btn button-outline-primary w-50 mb-2" type="button" (click)="downloadSPAJK()">
      <span *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" ><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJPK Syariah</span>
      <span *ngIf="!isLoading[3] && nasabah.nasabahNewCovering.partnerId == environment.partnerIdBTPN"><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJK</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
  </div>
  <div *ngIf="selectedItem.status == 'SUBMITTED' || selectedItem.status == 'REFERUW'">
    <p *ngIf="environment.partnerIdBSI == partnerId" class="bg-light rounded border shadow color-light-blue px-3 py-2 text-center fs-14"> Silahkan cetak SPAJK Syariah dan RIPLAY
      Personal untuk ditandatangani oleh calon PYD dan harap menghubungi PIC Allianz untuk informasi lebih lanjut.</p>
    <p *ngIf="nasabah.nasabahNewCovering.partnerId == environment.partnerIdBTPN" class="bg-light rounded border shadow color-light-blue px-3 py-2 text-center fs-14">Silahkan unduh ulang SPAJK dan RIPLAY Personal untuk dokumentasi pihak Bank atau Tertanggung</p>

    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadRiplayUnsigned()">
      <span *ngIf="!isLoading[2]"><i class="bi bi-arrow-down fw-bold"></i> Unduh RIPLAY Personal</span>
      <div *ngIf="isLoading[2]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadSPAJKUnsigned()">
      <span><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJPK Syariah</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>

    <button *ngIf="nasabah.nasabahNewCovering.partnerId == environment.partnerIdBTPN" class="btn button-outline-primary w-100 mb-2" type="button" (click)="downloadSPAJKRiplay()">
      <span *ngIf="!isLoading[3]"><i class="bi bi-arrow-down fw-bold"></i> Unduh SPAJK Dan RIPLAY</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>

    <button *ngIf="!isLoading[3] && environment.partnerIdBSI == partnerId && selectedItem.status == 'REFERUW'" class="btn btn-continue w-100 mb-2" type="button" (click)="editNameAppNo()" [disabled]="isEligibleEndorseNameAppNo">
      <span> Ajukan Perbaikan Nama Lengkap dan/atau No Aplikasi</span>
      <div *ngIf="isLoading[3]" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>

  </div>
</div>
